<script setup>
import { ref } from "vue";
import LIcon from "@/components/shared/LIcon.vue";
import { useUiStore } from "@/stores/ui";

const user = ref(JSON.parse(localStorage.getItem("userDetails")));
const currentCompany = ref(JSON.parse(localStorage.getItem("currentCompany")));
const uiStore = useUiStore();

const props = defineProps({
  data: Object,
});

const action = async (type, data) => {
  await uiStore.setModalAction(type);
  uiStore.setModalState(true);
  await uiStore.setModalData(data);
};

const loggedInId   = user.value?.user_id;
const loggedInRole = currentCompany.value?.pivot?.role?.name; // 'owner'|'admin'|'operator'|'super_admin'

const isSelf      = () => loggedInId === props.data?.id;
const rowIsOwner  = () => props.data?.role?.name === 'owner' || props.data?.role?.name === 'super_admin';
const loggedInIsPrivileged = () => loggedInRole === 'owner' || loggedInRole === 'super_admin';

// Edit rules:
//  • No one (except owner/super_admin) can edit an owner/super_admin row          (rule 2)
//  • Operator can only edit their own row                                          (rule 5)
const editDisabled = () => {
  if (rowIsOwner() && !loggedInIsPrivileged()) return true;
  if (loggedInRole === 'operator' && !isSelf()) return true;
  return false;
};

// Delete rules:
//  • No one can delete their own row                                               (rules 1, 3, 4)
//  • No one (except owner/super_admin) can delete an owner/super_admin row        (rule 2)
//  • Operator cannot delete any row                                                (rule 5)
const deleteDisabled = () => {
  if (isSelf()) return true;
  if (rowIsOwner() && !loggedInIsPrivileged()) return true;
  if (loggedInRole === 'operator') return true;
  return false;
};
</script>

<template>
  <div class="actions-cell">
    <button
      @click="action('edit_user', props.data)"
      type="button"
      class="icon-button"
      title="Edit"
      :disabled="editDisabled()"
    >
      <LIcon name="pencil" />
    </button>
    <button
      @click="action('delete_user', props.data)"
      type="button"
      class="icon-button danger"
      title="Delete"
      :disabled="deleteDisabled()"
    >
      <LIcon name="trash-2" />
    </button>
  </div>
</template>
